module.exports = __webpack_public_path__ + "static/media/import.5d1dc29c.svg";